module.exports = __webpack_public_path__ + "media/gundula2.f56ad68c.mp3";